import $ from 'jquery';

class Like{
    constructor(){
        this.events();
    }

    events(){

        // .bind(this) ---> using that to provide correct context involving Like class
        $(".like-box").on("click", this.ourClickDispatcher.bind(this));
    }


    // methods
    ourClickDispatcher(event){

        // $(event.target).closest(".like-box"); ---> involve the whole like box for click
        var currentLikeBox = $(event.target).closest(".like-box");

        // check if there is an HTML attr attribute data-exists="<?php echo $existStatus ?> at single-professor.php
        if(currentLikeBox.attr('data-exists') == 'yes'){

            // deleteLike(currentLikeBox) --> currentLikeBox is used to pass the current professor ID data
            this.deleteLike(currentLikeBox);
        }else {
            this.createLike(currentLikeBox);
        }
    }

    // createLike(currentLikeBox) --> currentLikeBox is used to pass the current professor ID data
    createLike(currentLikeBox){
        // REST API request by using Ajax method
        $.ajax({
            // Include Nonce to prove WordPress to make those requests
            beforeSend: (xhr) => {
                xhr.setRequestHeader('X-WP-Nonce', universityData.nonce);
            },

            // universityData is taken from functions.php and specified in associative array 'root_url' => get_site_url()
            // manageLike --> is specified within register_rest_route() function at like-route.php
            url: universityData.root_url + '/wp-json/university/v1/manageLike',
            type: 'POST',
            data: {'professorId': currentLikeBox.data('professor')},
            success: (response) => {
                // change data attr to YES
                currentLikeBox.attr('data-exists', 'yes');

                // Increment like value by + 1
                // parseInt() changes string number to integer
                var likeCount = parseInt(currentLikeBox.find(".like-count").html(), 10);

                // likeCount++ ---> increment by 1
                // currentLikeBox.find(".like-count").html(likeCount) ---> find the right class in HTML to execute the increment
                likeCount++;
                currentLikeBox.find(".like-count").html(likeCount);

                // 'response' argument stands for ID number returned
                currentLikeBox.attr('data-like', response);

                console.log(response);
            },
            error: (response) => {
                console.log(response);
            }
        });
    }

    // createLike(currentLikeBox) --> currentLikeBox is used to pass the current professor ID data
    deleteLike(currentLikeBox){
        // REST API request by using Ajax method
        $.ajax({
            // Include Nonce to prove WordPress to make those requests
            beforeSend: (xhr) => {
                xhr.setRequestHeader('X-WP-Nonce', universityData.nonce);
            },

            // universityData is taken from functions.php and specified in associative array 'root_url' => get_site_url()
            // manageLike --> is specified within register_rest_route() function at like-route.php
            url: universityData.root_url + '/wp-json/university/v1/manageLike',

            // select 'data-like' HTML attribute where the LIKE ID is exposed  
            data: {'like': currentLikeBox.attr('data-like')},
            type: 'DELETE',
            success: (response) => {
                // change data attr to NO
                currentLikeBox.attr('data-exists', 'no');

                // Decrease like value by - 1
                // parseInt() changes string number to integer
                var likeCount = parseInt(currentLikeBox.find(".like-count").html(), 10);

                // likeCount-- ---> decrease by 1
                // currentLikeBox.find(".like-count").html(likeCount) ---> find the right class in HTML to execute the increment
                likeCount--;
                currentLikeBox.find(".like-count").html(likeCount);

                // '' argument stands for empty value
                currentLikeBox.attr('data-like', '');

                console.log(response);
            },
            error: (response) => {
                console.log(response);
            }
        });
    }

}


export default Like;